import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Ce service permet d'historiser la liste des pages visitées par l'utilisateur   
 */
export interface PageInfo {
  url: string;
  name: string;
}

@Injectable({
  providedIn: 'root'
})
export class HistoryService {
  private previousPage: BehaviorSubject<PageInfo | null> = new BehaviorSubject<PageInfo | null>(null);

  setPreviousPage(page: PageInfo): void {
    this.previousPage.next(page);
  }

  getPreviousPage(): PageInfo | null {
    return this.previousPage.getValue();
  }
}
